var noopFunc = function noopFunc() {};
function uploadFiles(layerId, files) {
  var progressCB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noopFunc;
  var successCB = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noopFunc;
  var errorCB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : noopFunc;
  progressCB(0);
  var url = Oskari.urls.getRoute('WFSAttachments');
  var xhr = new XMLHttpRequest();
  var formData = new FormData();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('X-XSRF-TOKEN', Oskari.app.getXSRFToken());

  // Add following event listener
  xhr.upload.addEventListener('progress', function (e) {
    progressCB(e.loaded * 100.0 / e.total || 100);
  });
  xhr.addEventListener('readystatechange', function (e) {
    if (xhr.readyState === 4 && xhr.status === 200) {
      // Done. Inform the user
      successCB();
    } else if (xhr.readyState === 4 && xhr.status !== 200) {
      // Error. Inform the user
      errorCB();
    }
  });
  formData.append('layerId', layerId);
  files.forEach(function (f) {
    formData.append('file', f);
    if (f.locale) {
      formData.append('locale_' + f.name, f.locale);
    }
  });
  xhr.send(formData);
}
function listLayersWithFiles(successCB) {
  var layerJSON = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var url = Oskari.urls.getRoute('WFSAttachments', {
    json: layerJSON
  });
  jQuery.get(url, successCB);
}
function listFilesForLayer(layerId, successCB) {
  var url = Oskari.urls.getRoute('WFSAttachments') + "&layerId=".concat(layerId);
  jQuery.get(url + "&layerId=".concat(layerId), successCB);
}
function listFilesForFeature(layerId, featureId, successCB) {
  var url = Oskari.urls.getRoute('WFSAttachments') + "&layerId=".concat(layerId, "&featureId=").concat(featureId);
  jQuery.get(url, successCB);
}
function openFile(layerId, fileId) {
  var url = Oskari.urls.getRoute('WFSAttachments') + "&layerId=".concat(layerId, "&fileId=").concat(fileId);
  window.open(url, '_blank');
}
function removeFile(layerId, fileId, successCB) {
  var url = Oskari.urls.getRoute('WFSAttachments') + "&layerId=".concat(layerId, "&fileId=").concat(fileId);
  jQuery.ajax({
    url: url,
    type: 'DELETE',
    success: successCB
  });
}
function getFileLinksForFeature(layerId, files) {
  var url = Oskari.urls.getRoute('WFSAttachments') + "&layerId=".concat(layerId);
  var html = files.map(function (f) {
    var fileLink = "&fileId=".concat(f.id);
    if (f.external) {
      var fileName = encodeURIComponent(f.locale) + '.' + f.fileExtension;
      fileLink = "&featureId=".concat(f.featureId, "&name=").concat(fileName);
    }
    return "<a class=\"button\" target=\"_blank\" \n            rel=\"noopener noreferer\" href=\"".concat(url + fileLink, "\">").concat(f.locale + '.' + f.fileExtension, "</a>");
  });
  return "<div>\n        <b>Tiedostot:</b> ".concat(html.join(' '), "\n    </div>");
}
export var FileService = {
  uploadFiles: uploadFiles,
  listLayersWithFiles: listLayersWithFiles,
  listFilesForLayer: listFilesForLayer,
  listFilesForFeature: listFilesForFeature,
  openFile: openFile,
  removeFile: removeFile,
  getFileLinksForFeature: getFileLinksForFeature
};